'use strict';
import '../_logrocket';
import '../raven';
import angular from 'angular';
import '../angular-locale_es-ar';

import 'angular-material/angular-material';
import 'angular-animate/angular-animate';
import 'angular-material-icons/angular-material-icons';
import 'angular-aria/angular-aria';

import uiRouter from 'angular-ui-router';
import Services from './services';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import 'normalize.css';
import Filters from './filters';
import Directives from './directives';

import { permission, uiPermission } from 'angular-permission';
import definePermissions from '../permissions';
import localeConfig from '../locale-config.js';

import LocaleStorageModule from 'angular-local-storage';
import AngularInputMasks from 'angular-input-masks';
import ngMessages from 'angular-messages';
import 'angular-material-expansion-panel';
import ngSanitize from 'angular-sanitize';
import 'angular-drag-and-drop-lists';

// angular-moment-picker shit
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');
window['moment'] = moment;

import decoratorHelper from './async/decorator.helper';

require('angular-moment-picker');

angular
  .module('app', [
    'ngMaterial',
    'ngAnimate',
    'ngMdIcons',
    uiRouter,
    permission,
    uiPermission,
    Common,
    Services,
    Components,
    Filters,
    Directives,
    LocaleStorageModule,
    AngularInputMasks,
    ngMessages,
    'material.components.expansionPanels',
    ngSanitize,
    'dndLists',
    'moment-picker'
  ])
  .config(($locationProvider, $urlRouterProvider) => {
    'ngInject';
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');
    $urlRouterProvider.otherwise(function($injector) {
      var $state = $injector.get('$state');
      $state.go('home');
    });

    $urlRouterProvider.otherwise('/');

    // Prevent router from automatic state resolving
    $urlRouterProvider.deferIntercept();
  })
  .config([
    '$mdThemingProvider',
    'LoopBackResourceProvider',
    '$windowProvider',
    function($mdThemingProvider, LoopBackResourceProvider, $windowProvider) {
      'ngInject';
      var $window = $windowProvider.$get();
      let isDev = [8080].includes(parseInt($window.location.port, 10));
      let isTest = $window.location.href.match(/test/);
      if (isDev) {
        LoopBackResourceProvider.setUrlBase(
          'http://' + $window.location.hostname + ':3000/api'
        );
      }

      if (isDev || isTest) {
        $mdThemingProvider
          .theme('default')
          .primaryPalette('pink')
          .accentPalette('orange');
      } else {
        // production
        $mdThemingProvider
          .theme('default')
          .primaryPalette('teal')
          .accentPalette('pink');
      }
    }
  ])
  .config([
    '$qProvider',
    function($qProvider) {
      $qProvider.errorOnUnhandledRejections(false);
    }
  ])
  .config(localeConfig)
  .run(definePermissions)
  .run($injector => {
    'ngInject';
    decoratorHelper.injector = $injector;
  })
  .component('app', AppComponent);
